'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodashArrayFlattenDeep = require('lodash/array/flattenDeep');

var _lodashArrayFlattenDeep2 = _interopRequireDefault(_lodashArrayFlattenDeep);

var _ControlNoop = require('./ControlNoop');

var _ControlNoop2 = _interopRequireDefault(_ControlNoop);

var style = {
  background: '#eee',
  overflow: 'hidden',
  fontFamily: 'Menlo, Monaco, Consolas, "Lucida Console", monospace'
};
var styleItemTop = {
  float: 'left',
  width: '280px'
};
var styleItemSide = {
  marginBottom: '4px'
};

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Controls.Layout',

  propTypes: {
    children: _propTypes2['default'].node.isRequired,
    onTop: _propTypes2['default'].bool.isRequired
  },

  renderChildren: function renderChildren() {
    var _props = this.props;
    var onTop = _props.onTop;
    var children = _props.children;

    var childStyles = onTop ? styleItemTop : styleItemSide;
    return _lodashArrayFlattenDeep2['default'](children).filter(function (x) {
      return x && x.type !== _ControlNoop2['default'];
    }).map(function (x, i) {
      return _react2['default'].createElement(
        'div',
        { key: i, style: childStyles, className: 'react-demo__control-wrap' },
        x
      );
    });
  },

  render: function render() {
    return _react2['default'].createElement(
      'div',
      { style: style, className: 'react-demo__controls' },
      this.renderChildren()
    );
  }
});
module.exports = exports['default'];